var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"fade"},on:{"after-leave":_setup.handleAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_setup.visible),expression:"visible"}],staticClass:"m-toast",style:({ top: _setup.offsetTop })},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_setup.state.msg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }